import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authPostApi } from "../../services/api";
import { apiEndPoints } from "../../config/path";
import { showError } from "../../helpers/messageHelper";

type UserData = {
  uuid: string;
  full_name: string;
  email: string;
  isd_code: string;
  mobile_number: string;
  mobile_verified_at: string;
  is_profile_completed: boolean;
  screen_completed: number;
  type: number;
  current_type: number;
};

type ResponseData = {
  user?: UserData;
  is_already_logged_in?: boolean;
  access_token?: string;
  refresh_token?: string;
};

type SignUpDataState = {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  responseCode: number | null;
  responseData: ResponseData;
  token: string;
  isFromBooking: boolean;
  uuid: string;
  isReviewWrite: boolean;
  isBookMarking: boolean;
};

const initialState: SignUpDataState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  responseCode: 0,
  responseData: {},
  token: "",
  isFromBooking: false,
  uuid: "",
  isReviewWrite: false,
  isBookMarking: false,
};

export type ContactUsDataValues = {
  name: string;
  phoneNo: string;
  email: string;
  subject: string;
  message: string;
};

export const contactUsData = createAsyncThunk(
  "/contactUsData",
  async (values: ContactUsDataValues) => {
    try {
      const valuesData = values;
      
      const payload = await authPostApi(apiEndPoints.CONTACT_US_PATH, valuesData);
      
      return payload;
    } catch (e: any) {
      
      showError(e.response.data.responseMessage
      );
    }
  }
);
export const contactUsDataSlice = createSlice({
  name: "contactUsData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(contactUsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(contactUsData.fulfilled, (state, { payload }) => {
        
        state.isLoading = false;
        state.isSuccess = true;
        state.responseCode = payload && payload?.status;
        state.responseData = payload && payload?.data?.data;
      })
      .addCase(contactUsData.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      })
  },
});


export const contactUsDataReducer = contactUsDataSlice.reducer;
